import type { FaireProductEntity } from "../../entity_types/product";

export const p_vz2qescxw7: FaireProductEntity = {
  token: "p_vz2qescxw7",
  type: "product",
  name: "Muscle & Joint Care",
  brandToken: "b_dowxrh2caf",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/2e43638db720a7af9a003757d26091687629d9dbccf4e4a672e01a566880b19a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7dcc0bc49d18d45f3c88d6df112308c8677efcbeef8f1a2a7c43a9e061c39766.jpeg",
    "https://cdn.faire.com/fastly/cce321744ec439f4b8cc700645a226727e5be6867afb32f39600d4062f674d15.jpeg",
    "https://cdn.faire.com/fastly/d1a9a7b1f129b6c6391158f66f0f1ba25f00a8408c71a617b8a9da33e342c2c5.jpeg",
    "https://cdn.faire.com/fastly/eb6906f16929a93b2443096d1ec44e18c750b9bc74fd8ddfe36403dba635fe67.jpeg",
    "https://cdn.faire.com/fastly/87a8cf84b15f4954c83b109369fc2daf545e82b822e856b3d5e8731c7bdd705f.jpeg",
  ],
  priceDollars: 13,
  description:
    "\nMuscle & Joint Care Salve was originally created for runners with sore knees. We took our basic Pure Arnica Salve and gave it a boost! With the addition of potent essential oils and menthol crystals for deep penetrating relief of muscle and joint aches and pains, this salve will not disappoint you.\n\nPeople suffering from back pain or sciatica should absolutely give this salve a try. Users have reported that it acts quicker and lasts longer than another similar Arnica salve product. This is not a homeopathic product. Pure, concentrated Arnica oil, made in house, is the main ingredient for this salve.\n\nIngredients\n\n * Arnica (Arnica montana) Oil \n * Menthol Crystals \n * Wintergreen (Gaultheria procumbens) Essential Oil \n * Wild Harvested Sweet Birch Bud (Betula lenta) Essential Oil \n * Certified Organic Shea (Vitellaria paradoxa) Butter \n * Coconut (Cocos nucifera) Oil \n * Certified Organic Beeswax \nWhat We ❤ About This Product\n\nFolks with arthritis, joint pain, and many other muscle or skeletal issues have found relief—one customer even called it magic!",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:46.034Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
